module.exports = __webpack_public_path__ + "img/walterraab_unternehmenscoach.421a7d02.jpg";